import axios from 'lib/axios';

import {
  AUTH_ERROR,
  CARD_ERROR,
  CARD_LOADING,
  VERIFY_ERROR,
  CARD_RECEIVED,
  ACCOUNT_ERROR,
  SESSION_LOADING,
  SESSION_RECEIVED,
  AUTH_INVALID_ERROR,
  REGISTRATION_ERROR,
  SET_PASSWORD_ERROR,
  RESET_PASSWORD_ERROR,
  SESSION_AUTH_INVALID,
  SESSION_AUTH_RECEIVED,
  SESSION_RESET_LOADING,
  SESSION_RESET_SUCCESS,
  SESSION_GET_LOADING,
  INVITATIONS_RECEIVED,
  INVITATIONS_LOADING,
  INVITATIONS_ERROR,
  SESSION_DETAILS_LOADING,
  SESSION_VERIFY_RECEIVED,
  SESSION_REGISTRATION_RESET,
  SESSION_REGISTRATION_RECEIVED,
  INVITE_UPDATED,
  INVITE_RESPONSE_LOADING,
  INVITE_RESPONSE_ERROR,
  INVITATION_LOADING,
  INVITATION_RECEIVED,
  INVITATION_ERROR,
  INVITATION_ERROR_CLEAR
} from 'constants/actions';

import { dispatchSetMessage } from './messages';

import {
  E_AUTH_UNKNOWN,
  E_VERIFY_UNKNOWN,
  E_CARD_ADD_UNKNOWN,
  E_INVITATION_UNKNOWN,
  E_CARD_REMOVE_UNKNOWN,
  E_INVITATIONS_UNKNOWN,
  E_AUTH_INVALID_UNKNOWN,
  E_REGISTRATION_UNKNOWN,
  E_SET_PASSWORD_UNKNOWN,
  E_ACCOUNT_UPDATE_UNKNOWN,
  E_RESET_PASSWORD_UNKNOWN,
  E_INVITE_RESPONSE_UNKNOWN,
} from 'constants/errors';

import {
  M_ACCOUNT_UPDATED,
  M_ACCOUNT_CARD_ADDED,
  M_ACCOUNT_CARD_REMOVED,
  M_WELCOME_SEARCHLIGHT,
  M_INVITE_RESPONSE_UPDATED
} from 'constants/messages';

import { dispatcher } from 'lib/redux';

export const loadingCard = (value) => () => {
  dispatcher(CARD_LOADING, value);
};

export const login = (credentials) => async () => {
  dispatcher(SESSION_LOADING, true);

  try {
    var response = await axios.post('session', credentials);

    dispatcher(SESSION_LOADING, false);
    dispatcher(SESSION_AUTH_RECEIVED, response.data);
  } catch (e) {
    dispatcher(SESSION_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(AUTH_ERROR, data.error);
    } catch (e) {
      dispatcher(AUTH_ERROR, E_AUTH_UNKNOWN);
    }
  }
};

export const getSession = () => async () => {
  dispatcher(SESSION_GET_LOADING, true);

  try {
    var response = await axios.get('session');

    dispatcher(SESSION_GET_LOADING, false);
    dispatcher(SESSION_AUTH_RECEIVED, { ...response.data, updated: Date.now() } );
  } catch (e) {
    dispatcher(SESSION_GET_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(AUTH_ERROR, data.error);
    } catch (e) {
      dispatcher(AUTH_ERROR, E_AUTH_UNKNOWN);
    }
  }
};

export const endSession = () => async () => {
  dispatcher(SESSION_LOADING, true);

  try {
    await axios.delete('session');

    dispatcher(SESSION_LOADING, false);
    dispatcher(SESSION_AUTH_INVALID, false);
  } catch (e) {
    dispatcher(SESSION_LOADING, false);
    dispatcher(AUTH_INVALID_ERROR, E_AUTH_INVALID_UNKNOWN);
  }
};

export const resetRegister = () => async () => {
  dispatcher(SESSION_REGISTRATION_RESET, true);
};

export const register = (data) => async () => {
  dispatcher(SESSION_LOADING, true);

  try {
    var response = await axios.post('register', data); 

    dispatcher(SESSION_LOADING, false);
    dispatcher(SESSION_REGISTRATION_RECEIVED, response.data);
  } catch (e) {
    dispatcher(SESSION_LOADING, false);

    if (e.response && e.response.data && e.response.data.message) {
      dispatcher(REGISTRATION_ERROR, e.response.data.message);
    } else {
      dispatcher(REGISTRATION_ERROR, E_REGISTRATION_UNKNOWN);
    }
  }
};

export const verify = (data) => async () => {
  dispatcher(SESSION_LOADING, true);

  try {
    var response = await axios.post('session/verify', data);

    dispatcher(SESSION_LOADING, false);
    dispatcher(SESSION_AUTH_INVALID);
    dispatchSetMessage(M_WELCOME_SEARCHLIGHT);
    dispatcher(SESSION_VERIFY_RECEIVED, response.data);
  } catch (e) {
    dispatcher(SESSION_LOADING, false);
    dispatcher(VERIFY_ERROR, E_VERIFY_UNKNOWN);
  }
};

export const getCard = () => async () => {
  dispatcher(CARD_LOADING, true);

  try {
    var response = await axios.get('session/card');

    dispatcher(CARD_LOADING, false);
    dispatcher(CARD_RECEIVED, response.data);
  } catch (e) {
    dispatcher(CARD_LOADING, false);

    if (e.canceled) return;
  }
};

export const addCard = (data) => async (dispatch) => {
  dispatcher(CARD_LOADING, true);

  try {
    var response = await axios.post('session/card', data);

    dispatchSetMessage(M_ACCOUNT_CARD_ADDED);

    dispatcher(CARD_LOADING, false);
    dispatcher(SESSION_RECEIVED, response.data);
    dispatch(getCard());
  } catch (e) {
    dispatcher(CARD_LOADING, false);

    if (e.canceled) return;

    try {
      var responseData = JSON.parse(e.request.responseText);
      dispatcher(CARD_ERROR, responseData || E_CARD_ADD_UNKNOWN);
    } catch (err) {
      dispatcher(CARD_ERROR, E_CARD_ADD_UNKNOWN);
    }
  }
};

export const removeCard = () => async () => {
  dispatcher(CARD_LOADING, true);

  try {
    await axios.delete('session/card');

    dispatchSetMessage(M_ACCOUNT_CARD_REMOVED);
    dispatcher(CARD_LOADING, false);
    dispatcher(CARD_RECEIVED, null);
  } catch (e) {
    dispatcher(CARD_LOADING, false);

    if (e.canceled) return;

    dispatcher(CARD_ERROR, E_CARD_REMOVE_UNKNOWN);
  }
};

export const updateAccount = (data) => async () => {
  dispatcher(SESSION_DETAILS_LOADING, true);

  try {
    var response = await axios.put('session/account', data);

    dispatchSetMessage(M_ACCOUNT_UPDATED);
    dispatcher(SESSION_DETAILS_LOADING, false);
    dispatcher(SESSION_RECEIVED, response.data);
  } catch (e) {
    dispatcher(SESSION_DETAILS_LOADING, false);

    if (e.canceled) return;

    dispatcher(ACCOUNT_ERROR, E_ACCOUNT_UPDATE_UNKNOWN);
  }
};

export const updateUser = (data) => async () => {
  dispatcher(SESSION_DETAILS_LOADING, true);

  try {
    var response = await axios.put('session', data);

    dispatchSetMessage(M_ACCOUNT_UPDATED);
    dispatcher(SESSION_DETAILS_LOADING, false);
    dispatcher(SESSION_RECEIVED, response.data);
  } catch (e) {
    dispatcher(SESSION_DETAILS_LOADING, false);

    if (e.canceled) return;

    dispatcher(ACCOUNT_ERROR, E_ACCOUNT_UPDATE_UNKNOWN);
  }
};

export const resetPassword = (emailAddress) => async () => {
  dispatcher(SESSION_RESET_LOADING, true);

  try {
    await axios.post('session/reset-password', { emailAddress });

    dispatcher(SESSION_RESET_LOADING, false);
    dispatcher(SESSION_RESET_SUCCESS, true);
  } catch (e) {
    dispatcher(SESSION_RESET_LOADING, false);

    if (e.canceled) return;

    dispatcher(RESET_PASSWORD_ERROR, E_RESET_PASSWORD_UNKNOWN);
  }
};

export const setPassword = (data) => async () => {
  dispatcher(SESSION_RESET_LOADING, true);

  try {
    await axios.post('session/set-password', data);

    dispatcher(SESSION_RESET_LOADING, false);
    dispatcher(SESSION_RESET_SUCCESS, true);
  } catch (e) {
    dispatcher(SESSION_RESET_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data && e.response.data.message) {
      dispatcher(AUTH_ERROR, e.response.data.message);
    } else {
      dispatcher(SET_PASSWORD_ERROR, E_SET_PASSWORD_UNKNOWN);
    }
  }
};


export const getInvitations = () => async () => {
  dispatcher(INVITATIONS_LOADING, true);

  try {
    var response = await axios.get('session/account/invitations');

    dispatcher(INVITATIONS_LOADING, false);
    dispatcher(INVITATIONS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(INVITATIONS_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(INVITATIONS_ERROR, data.error);
    } catch (e) {
      dispatcher(INVITATIONS_ERROR, E_INVITATIONS_UNKNOWN);
    }
  }
};

export const getInvitation = (invite_token) => async () => {
  dispatcher(INVITATION_LOADING, true);

  try {
    var response = await axios.get(`session/account/invitations/${invite_token}`);

    dispatcher(INVITATION_LOADING, false);
    dispatcher(INVITATION_RECEIVED, response.data);
  } catch (e) {
    dispatcher(INVITATION_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(INVITATION_ERROR, data.error);
    } catch (e) {
      dispatcher(INVITATION_ERROR, E_INVITATION_UNKNOWN);
    }
  }
};

export const updateInvite = (inviteResponse) => async (dispatch) => {
  dispatcher(INVITE_RESPONSE_LOADING, true);

  try {
    await axios.put(`session/account/invitations/${inviteResponse.id}`, { accepted: inviteResponse.response });
    
    dispatcher(INVITE_UPDATED, inviteResponse.id);
    dispatchSetMessage(M_INVITE_RESPONSE_UPDATED);
    dispatcher(INVITE_RESPONSE_LOADING, false);

    if (inviteResponse.response) {
      window.location.reload(false);
    }
  } catch (e) {
    dispatcher(INVITE_RESPONSE_LOADING, false);

    if (e.canceled) return;

    dispatcher(INVITE_RESPONSE_ERROR, E_INVITE_RESPONSE_UNKNOWN);
  }
};

export const clearInviteError = () => async (dispatch) => {
  dispatcher(INVITATION_ERROR_CLEAR);
}